<template>
    <div>
        <main class="authentication">
            <div class="authentication__content">
                <div class="authentication__form authentication__form--login">
                    <h1 class="authentication__form-title">{{ trans('authentication.login.title') }}</h1>
                    <user-login @submit="login" />
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';
import { UserLogin, AuthApi } from 'relapp-auth';

export default {
    components: {
        UserLogin
    },
    mixins: [pageLoadingStatusMixin],

    props: {
        token: {
            type: String,
            required: false
        },
        userId: {
            type: Number,
            required: false
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
        if (this.isLoggedIn) {
            this.$router.push({ name: 'services' });
        } else if (this.token && this.userId) {
            this.loginAs({ token: this.token, userId: this.userId });
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn'
        })
    },
    methods: {
        /**
         * Call the login endpoint.
         *
         * @param {object} form
         */
        login(form) {
            this.startLoading();
            AuthApi.login(form).then(() => {
                this.finishLoading();
                this.$router.push({ name: 'services' });
            });
        },
        /**
         * Call the login as endpoint.
         *
         * @param {string} token
         * @param {number} userId
         */
        loginAs({ token, userId }) {
            this.startLoading();
            AuthApi.loginAs({ token: token, userId: userId }).then(() => {
                this.finishLoading();
                this.$router.push({ name: 'services' });
            });
        }
    }
};
</script>
